<template>
  <custom-modal
    :title="` ${form.id ? form.id + ' - ' : 'New'} Leave Request --`"
    v-model="show"
    @close="close()"
    :loading="loading"
    :width="!form.id ? 600 : 1100"
    color="grey lighten-2"
    @reload="form.id && edit(form.id)"
  >
    <div style="min-height: 500px">
      <v-row class="text-right dhivehi" dir="rtl" no-gutters>
        <v-col cols="12" :md="form.id ? 7 : 12">
          <div>
            <v-chip x-small color="blue" dark class="text-uppercase" v-if="form.id">
              {{ form.status }}
            </v-chip>

            <v-icon
              v-if="$can('hrms') && form && form.status && form.status.match(/_(unit|section)_leave_approval$/)"
              @click="syncUnitStatus(form.id)"
              class="mr-2"
              v-tooltip="'Update unit/section status'"
            >mdi-account-sync-outline</v-icon>
          </div>

          <pending-tasks v-if="$can('all_permissions')" class="mt-3 mb-3" :selectedUser="User.username" ref="userActions"></pending-tasks>


          <v-card color="transparent" flat v-if="isEditable">
            <v-form v-model="formValid" ref="form">
              <v-card class="px-2">
                <div v-if="form.staff && form.staff.unit_name">
                  <span class="grey--text">ޔުނިޓް: </span>
                  <span>{{ form.staff.unit_name }}</span>
                </div>
                <div v-if="form.staff && form.staff.DhiSectionName">
                  <span class="grey--text">ސެކްޝަން: </span>
                  <span>{{ form.staff.DhiSectionName }}</span>
                  <v-divider class="mb-2"></v-divider>
                </div>

                <new-select
                  label="ޗުއްޓީގެ ބާވަތް:"
                  :hasSearch="true"
                  v-model="form.leave_id"
                  :options="Object.values(types)"
                  optionKey="iLeaveID"
                  optionLabel="cDhiLeaveName"
                  class="pb-1 dhiv-select"
                  mode="object"
                  :disabled="!!leave_type"
                  @input="getMyRemainingDays(), (needsSave = true)"
                >
                </new-select>

                <v-simple-table
                  color="blue"
                  class="mb-2"
                  dense
                  v-if="form.leave_id && myRemainingDays.iDaysAllowed"
                >
                  <thead>
                    <tr>
                      <th class="text-right">މުއްދަތު</th>
                      <th class="text-left">ބާކީ ދުވަހުގެ އަދަދު</th>
                      <th v-if="form.leave_id && form.leave_id.iLeaveID == 6">
                        ސެޓްފިކެޓާ ނުލާ ބާކީ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="myRemainingDays && myRemainingDays.iDaysAllowed">
                      <td class="english">
                        {{ myRemainingDays.dtFromDate }} -
                        {{ myRemainingDays.dtToDate }}
                      </td>
                      <td class="english text-left">
                        {{ parseInt(myRemainingDays.iBalance) }}
                      </td>
                      <td
                        class="english text-left"
                        v-if="form.leave_id && form.leave_id.iLeaveID == 6"
                      >
                        {{ myRemainingDays.noCertLeft }}
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <v-alert
                  dense
                  text
                  type="info"
                  border="top"
                  class="py-3 text-left english"
                  dir="ltr"
                  v-if="form.leave_id && form.leave_id.details"
                >
                  <p v-html="form.leave_id.details"></p>
                </v-alert>
              </v-card>

              <v-card class="my-6 px-3" v-if="form.leave_id">
                <v-row class="mt-2 d-flex flex-row pb-3">
                  <v-col cols="12" class="d-flex flex-row">
                    
                    <v-row dense>
                      <v-col cols="6" sm="4">
                        <div class="d-flex flex-column">
                          <span class="input-label">ޗުއްޓީ ފަށާ ތާރީޚް: </span>
                          <date-picker
                            class="english"
                            v-model="form.from_date"
                            format="DD-MM-YYYY"
                            value-type="YYYY-MM-DD"
                            :disabled-date="disabledStartDate"
                            @input="getLeaveEndDateWithCount(), (needsSave = true)"
                            style="width: 100%;"
                          ></date-picker>
                            <!-- style="max-width: 150px;" -->
                        </div>
                      </v-col>

                      <v-col cols="6" sm="4">
                        <div class="d-flex flex-column" v-if="form.from_date">
                          <span class="input-label">ޗުއްޓީ ނިމޭ ތާރީޚް: </span>
                          <date-picker
                            class="english"
                            v-model="form.to_date"
                            format="DD-MM-YYYY"
                            value-type="YYYY-MM-DD"
                            :disabled-date="disabledEndDate"
                            @input="getLeaveEndDateWithCount(), (needsSave = true)"
                            style="width: 100%;"
                          ></date-picker>
                            <!-- style="max-width: 150px;" -->
                        </div>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <div v-if="form.from_date && form.to_date">
                          <span class="input-label"> ދުވަސް: </span>
                          <v-text-field
                            type="number"
                            dense
                            v-model="form.number_of_days"
                            @blur="getLeaveEndDateWithCount('end_date'), (needsSave = true)"
                            outlined
                            style="max-width: 150px;"
                          ></v-text-field>
                        </div>
                      </v-col>
                    </v-row>

                  </v-col>
                </v-row>

                <v-row></v-row>

                <div v-if="preApprovalRequired">
                  <v-alert
                    border="top"
                    color="red lighten-2"
                    dense
                    class="english text-left"
                    dir="ltr"
                  >
                    <h6>Pre approval request is required.</h6>
                  </v-alert>
                </div>
              </v-card>

              <v-card class="mt-2" v-if="form.leave_id">
                <div v-if="form.leave_id && form.leave_id == 1">
                  <span class="input-label">ޗުއްޓީ ހޭދަކުރާ ތަން: </span>
                  <v-autocomplete
                    dense
                    outlined
                    :items="leave_locations"
                    item-text="option"
                    item-value="id"
                    v-model="form.place_of_leave"
                    :rules="ruleRequired"
                  ></v-autocomplete>

                  <div v-if="form.place_of_leave && form.place_of_leave == '2'">
                    <span class="input-label">އަތޮޅު: </span>
                    <v-autocomplete
                      dense
                      outlined
                      :items="atolls"
                      v-model="form.atoll_id"
                      item-text="cDhiAtollName"
                      item-value="iAtollID"
                    ></v-autocomplete>
                  </div>
                </div>

                <div class="pb-2">
                  <div class="grey px-1">ސަބަބު</div>
                  <tiptap-editor
                    outlined
                    :value="form.reason"
                    @input="value => (form.reason = value)"
                    class="dhivehi"
                    v-model="form.reason"
                  ></tiptap-editor>
                </div>
              </v-card>

              <!-- handover form -->
              <!-- <v-alert dense text type="info"  class="mt-3 text-left english" dir="ltr">
                    Handover form will be available three days prior to leave. Please remember to fill, as failure to do so will result in rejecting this request!
                  </v-alert> -->

              <!-- work from home registration modal -->
              <!-- <div v-if="form.id && form.leave_id == 20" class="mt-3">
                    <v-btn color="blue" class="white--text" v-if="!form.wfh_registration" small @click="$refs.wfhFormModal.open(form.id)">ވޯކް ފްރޮމް ހޯމް ރެޖިސްޓްރަ ފޯމު</v-btn>
                    <v-btn color="blue" class="white--text" v-if="form.wfh_registration" small @click="$refs.wfhFormModal.edit(form.wfh_registration.id)">ވޯކް ފްރޮމް ހޯމް ރެޖިސްޓްރަ ފޯމު</v-btn>
                  </div> -->
            </v-form>
          </v-card>

          <v-card v-if="form.id && !isEditable">
            <v-simple-table dense class="rsp-table">
              <tbody>
                <tr>
                  <td>
                    <label class="grey--text dhivehiHeading">ޗުއްޓީގެ ބާވަތް: </label>
                    {{ form.leave_id ? form.leave_id.cDhiLeaveName : null }}
                  </td>
                  <td width="30%">
                    <label class="grey--text dhivehiHeading"> އެދުނު ދުވަސް: </label>
                    {{ $localeDateTime(form.submitted_at) }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="grey--text dhivehiHeading">މުއްދަތު : </label>
                    {{ $localeDate(form.from_date) }} - {{ $localeDate(form.to_date) }}
                  </td>
                  <td width="40%">
                    <label class="grey--text dhivehiHeading"> ދުވަސް : </label>
                    <small class="english"> {{ form.number_of_days }} </small>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label class="grey--text dhivehiHeading">ސަބަބު : </label>
                    <p v-html="form.reason"></p>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>

          <FormBlocks
            v-if="form.id && form.form_sections && !needsSave"
            v-model="form.form_sections"
            :filled.sync="blocksFilled"
            :item-id="form.id"
            :disabled="
              !['draft', 'correction_required', 'pending_handover'].includes(form.status)
            "
            model="LeaveRequest"
            ref="formBlocks"
          />
        </v-col>

        <v-col v-if="form.id" cols="12" md="5" class="pr-0 pr-md-3">
          <div v-if="form.id">
            <ApprovalStages :model="'LeaveRequest'" :refID="form.id" />
          </div>
          <ActivityLog
            dir="ltr"
            class="col-md-3 col-lg-4 english text-left"
            model="LeaveRequest"
            :ref_id="form.id"
          />
        </v-col>
      </v-row>
    </div>

    <template #actions>
      <v-btn
        small
        outlined
        color="success"
        @click="save()"
        :disabled="!isFilled"
        v-if="!form.id"
      >
        {{ preApprovalRequired ? ' save pre approval' : 'save draft' }}
      </v-btn>
      <!-- prettier-ignore -->
      <v-btn
        small
        outlined
        color="blue"
        @click="save('update', !needsSave)"
        :disabled="!(isFilled && (needsSave || blocksFilled))"
        v-if="form.id && User && User.staff && User.staff.ISMID == form.staff_id && (isEditable || ['draft', 'correction_required', 'pending_submission', 'pending_handover'].includes(form.status))"
      >
        update
      </v-btn>
      <!-- prettier-ignore -->
      <v-btn
        small
        outlined
        color="success"
        @click="save('submit')"
        :disabled="!isFilled || !blocksFilled || needsSave"
        v-if="form.id &&  User && User.staff && User.staff.ISMID == form.staff_id && ['draft', 'pending_submission', 'correction_required', 'pending_handover', ].includes(form.status)"
      >
        submit
      </v-btn>
    </template>
    <view-pdf-modal ref="pdfModal"></view-pdf-modal>
    <pre dir="ltr" v-if="$can('all_permissions')">{{ form }}</pre>
  </custom-modal>
</template>

<script>
import CustomModal from '../util/CustomModal.vue'
import FileShareUpload from '../util/file_upload/FileShareUpload.vue'
import ViewPdfModal from '../util/ViewPdfModal.vue'
import PendingTasks from './PendingTasks.vue'
import ApprovalStages from '@/components/approval-components/approvalStages.vue'
import TiptapEditor from '../util/NewTiptapEditor.vue'
import ActivityLog from '../user-activity/ActivityLog.vue'
import FormBlocks from '../form-blocks/Blocks.vue'
import CustomSelect from '../util/CustomSelect.vue'

export default {
  props: ['leave_type'],
  components: {
    CustomModal,
    CustomSelect,
    FileShareUpload,
    ViewPdfModal,
    TiptapEditor,
    ApprovalStages,
    ActivityLog,
    FormBlocks,
    PendingTasks
  },
  data: () => ({
    atolls: [],
    formValid: false,
    show: false,
    loading: false,
    types: [],
    leave_locations: [
      { id: '1', option: 'ވަޒީފާ އަދާކުރާ ރަށުގައި', optionEng: 'Island of Employment' },
      {
        id: '2',
        option: 'ވަޒީފާ އަދާކުރާ ރަށްނޫން އެހެން ރަށެއްގައި',
        optionEng: 'Other Island',
      },
      { id: '3', option: 'ޤައުމުން ބޭރުގައި', optionEng: 'Abroad' },
    ],
    form: {
      leave_id: '',
      reason: '',
      from_date: '',
      to_date: '',
      number_of_days: null,
      hand_over_required: false,
    },
    ruleRequired: [v => !!v || 'ފުރިހަމަ ހުރުމަށް!'],
    myRemainingDays: {},
    preApprovalRequired: false,
    blocksFilled: false,
    needsSave: false,
  }),

  computed: {
    isFilled() {
      // prettier-ignore
      return (
        this.form.from_date
        && this.form.to_date
        && this.form.to_date >= this.form.from_date
        && ((this.myRemainingDays?.iBalance > 0
        // TODO: remove allowed leaves with no balance
        && parseInt(this.form.number_of_days) <= this.myRemainingDays.iBalance) || [20, 4].includes(this.form.leave_id?.iLeaveID))
        && this.form.reason.length
        && this.form.reason != '<p></p>'
      )
    },

    isEditable() {
      return ['draft'].includes(this.form.status) || !this.form.id || this.form.editable
    },
  },
  methods: {
    initDate() {
      if (![6, 3].includes(this.leave_type)) return

      this.$axios.get(`/api/timestamp`).then((resp) => {
        this.form.from_date = resp.data.today
        this.form.to_date = resp.data.today

        this.getLeaveEndDateWithCount()
      })
    },

    disabledStartDate(date) {
      let today = new Date()
      today.setHours(0, 0, 0, 0)
      let day = new Date(date).getDay()
      return day === 5 || day === 6 || date < today
    },

    disabledEndDate(date) {
      let day = new Date(date).getDay()
      let toDate = new Date(this.form.from_date)
      toDate.setHours(0, 0, 0)
      return day === 5 || day === 6 || date < toDate
    },

    getLeaveEndDateWithCount(type = 'days') {
      if (!this.form.leave_id || !this.form.from_date || !this.form.to_date) return

      this.loading = true
      let postData = {
        calculate_type: type,
        type: this.form.leave_id.iLeaveID,
        from_date: this.form.from_date,
        to_date: this.form.to_date,
        number_of_days: this.form.number_of_days,
      }

      this.form.id ? (postData.form_id = this.form.id) : null

      this.$axios
        .get(`/api/leave-request/getLeaveEndDateWithDayCount`, { params: postData })
        .then(resp => {
          this.preApprovalRequired = false
          if (resp.data.end_date)
            this.form.to_date = resp.data.end_date.split('/').reverse().join('-')
          this.form.number_of_days = parseInt(resp.data.days)
        })
        .catch(error => {
          let errorData = error.response.data.data
          if (errorData.end_date) this.form.to_date = errorData.end_date
          if (errorData.days) this.form.number_of_days = errorData.days
          if (errorData.preApproval) this.preApprovalRequired = true
        })
        .finally(() => (this.loading = false))
    },

    getMyRemainingDays() {
      if (!this.form.leave_id.iLeaveID) return
      this.loading = true
      this.$axios
        .get(
          `/api/leave-request/getMyRemainingLeaves/type/${this.form.leave_id.iLeaveID}?staff_id=${this.form.staff_id}`
        )
        .then(resp => (this.myRemainingDays = resp.data))
        .finally(() => (this.loading = false))
    },

    getBlocks() {
      if (!this.form.id) return
      this.$axios.get(`/api/leave-request/${this.form.id}/form-blocks`).then(res => {
        this.form.form_blocks = res.data
        // this.form = { ...this.form, form_blocks: res.data }
      })
    },

    getItem() {
      this.loading = true
      return this.$axios
        .get(
          `/api/leave_requests/${this.form.id}?with=staff,file,wfhRegistration,handoverForm,leaveType`
        )
        .then(resp => {
          this.form = resp.data
          this.form.leave_id = this.form.leave_type
          this.needsSave = false
          this.loading = false
          this.getLeaveEndDateWithCount()
          this.getMyRemainingDays()
        })
        .finally(() => (this.loading = false))
    },

    edit(id) {
      this.form.id = id
      this.getAtolls()
      this.getTypes().then(() => {
        this.getItem()
      })
      this.initializePending()
      this.show = true
    },

    async save(reqType, saveBlocks = false) {
      let data = this.form
      data.submit = data.update = null
      if (reqType) data[reqType] = true
      data.pre_approval_required = this.preApprovalRequired

      this.loading = true
      try {
        await this.$refs.formBlocks?.save()

        let res = await this.$axios.post(`/api/leave-request/saveLeaveRequest`, data)
        if (!this.form.id) this.form.id = res.data.data?.id
        await this.getItem()
      } finally {
        this.loading = false
      }
    },


    uploaded(data) {
      this.form.file_id = data.id
      this.save('update')
    },

    getTypes() {
      return this.$axios.get('api/leave-request/getLeaveTypes').then(resp => {
        this.types = resp.data
        this.types.push({
          iLeaveID: 20,
          cEngLeaveName: 'Work From Home',
          cDhiLeaveName: 'ވޯކް ފްރޮމް ހޯމް',
        })
        if (this.leave_type && this.form) {
          if (this.leave_type == 6) {
            this.types.push({
              iLeaveID: 6,
              cEngLeaveName: 'Sick Leave',
              cDhiLeaveName: 'ސަލާމުގެ ޗުއްޓީ',
            })
          }
          this.form.leave_id = this.types.find(i => i.iLeaveID == this.leave_type)
          if (this.form.leave_id) this.getMyRemainingDays()
        }
      })
    },

    getAtolls() {
      this.$axios.get('/api/general-lists/getAtolls').then(resp => {
        this.atolls = resp.data
      })
    },

    syncUnitStatus() {
      return this.$axios.put(`/api/leave-request/${this.form.id}/sync-unit-status`)
        .then(() => this.getItem())
    },

    handleDefinitionsUpdated(index, updatedDefinitions) {
      this.$set(this.form.form_sections, index, {
        ...this.form.form_sections[index],
        definitions: updatedDefinitions,
      })
      this.$forceUpdate()
    },

    initializePending() {
      if (this.User) {
        this.$nextTick(() => {
          this.$refs.userActions?.getUserActions()
        })
      }
    },

    open() {
      if (this.leave_type) this.form.leave_id = this.leave_type
      this.getTypes().then(() => this.initDate())
      this.getAtolls()
      this.initializePending()

      this.form.staff_id = this.User.staff.ISMID

      this.show = true
    },

    close() {
      this.$emit('reload')
      this.resetData()
    },

    resetData() {
      Object.assign(this.$data, this.$options.data())
    },
  },
}
</script>

<style scoped>
p {
  margin-bottom: 1px !important;
}
.v-list.v-select-list.v-sheet.theme--light.v-list--dense.theme--light {
  direction: rtl !important;
  font-family: 'Faruma' !important;
}
</style>